import React, {useEffect, useState} from 'react';
import { getActivityVideo, getActivityQuestionImage, getActivityVideo2 } from '../../../actions/activities_actions';
import ReactPlayer from 'react-player'
import { useParams} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styles from '../../css/styling.module.css';
import YouTube from 'react-youtube';
import Dropzone from "react-dropzone";
import { sendActivityReplyAnswers, sendSharableSurveyReplyAnswers } from '../../../actions/activities_reply_actions';
import imageCompression from 'browser-image-compression';



const Question_With_Image2 = (props) => {


 const compressImage = async (file) => {

        // Skip compression if already under 300KB
    // if (fileSizeInMB < 0.3) {
    //     console.log('Image already small, skipping compression');
    //     return file;
    // }

        const options = {
            maxSizeMB: 0.3,           // Max output size: 1MB
            maxWidthOrHeight: 1920, // Scale down if wider/taller than 1920px
            useWebWorker: true,     // Non-blocking, runs in background thread
            initialQuality: 0.8,
            
        };

        try {
            const compressedFile = await imageCompression(file, options);
            // compressedFile is a Blob — convert back to File to keep the name
            return new File([compressedFile], file.name, { type: compressedFile.type });
        } catch (error) {
            console.error('Compression failed, using original:', error);
            return file; // fallback to original if compression fails
        }
    }

    // On image Select
    const onImageSelect = async (file) => {

        document.getElementById(`error-msg-${props.id}`).innerHTML = "";

        if (!file || file.length === 0) {
            return;
        }

        const currentImages = props.allContent.content[props.categoryIndex].questions[props.questionIndex].image || [];
        const limit = !Number.isNaN(parseInt(props.filesLimit)) && parseInt(props.filesLimit) > 0 ? parseInt(props.filesLimit) : 1;

        if (currentImages.length >= limit) {
            return;
        }

        const selectedFile = file[0];
        let fileExtension = selectedFile.name.split('.').pop().toLowerCase();

        if (fileExtension !== "png" && fileExtension !== "jpg" && fileExtension !== "jpeg") {
            document.getElementById(`error-msg-${props.id}`).innerHTML = `
                <div class="my-2">
                    <div class="alert alert-danger mb-0">
                        Invalid file type
                    </div>
                </div>
            `;
            return;
        }

        const maxSizeBytes = !Number.isNaN(parseFloat(props.filesSize)) ? (parseFloat(props.filesSize) * 1048576) : (50 * 1048576);

        if (selectedFile.size > maxSizeBytes) {
            document.getElementById(`error-msg-${props.id}`).innerHTML = `
                <div class="my-2">
                    <div class="alert alert-danger mb-0">
                        File size must not exceed ${props.filesSize ? props.filesSize : "50"} MB
                    </div>
                </div>
            `;
            return;
        }

        const compressed = await compressImage(selectedFile);

        if (props.allContent.content[props.categoryIndex].questions[props.questionIndex].image) {
            props.allContent.content[props.categoryIndex].questions[props.questionIndex].image.push(compressed);
        } else {
            props.allContent.content[props.categoryIndex].questions[props.questionIndex].image = [compressed];
        }

        props.allContent.content[props.categoryIndex].questions[props.questionIndex].q = props.questionNo;
        props.setContent({ ...props.allContent });
    }

 

    // on Cancel Image
    const onCancelImg = (index) => {
        props.allContent.content[props.categoryIndex].questions[props.questionIndex].image.splice(index, 1);
        props.setContent({ ...props.allContent });
    }

    // On Comment
    const onComment = (e) => {

        props.allContent.content[props.categoryIndex].questions[props.questionIndex].comment = e.target.value;
        props.setContent({ ...props.allContent });

    }

    const opts = {
        width: '640',
        height: '360',
        playerVars: {
          autoplay: 0
        },
    };

    const params = useParams();
    const userId = params.UserId
    const dispatch = useDispatch();
    const catId = props.categoryId
    const questionIndex = props.questionIndex
    const [qVideo, setQVideo] = useState([])
    const [qImage, setQImage] = useState({})
    const [isLoading, setIsLoading] = useState(true);
    const [previewIndex, setPreviewIndex] = useState(null);

    useEffect(() => {
        if(props.questionFile && props.questionFile !==''){
        if(params.surveyid || params.ActivityId || params.activityid){
            //console.log('cat id, ques index ->',catId, questionIndex)
    dispatch(getActivityVideo2(params.surveyid || params.ActivityId || params.activityid, catId, questionIndex))
    .then((response) =>{
        try{
        //console.log('question video in respodant side survey->',response.payload.content.fileData)
            const fileData = response.payload.content.fileData;
            setQVideo(Array.isArray(fileData) ? fileData : [fileData]);

        }catch(err)
            {
                console.log('video not available')
            }
        setIsLoading(false);
        
    })
    .catch(err=>err)

    // dispatch(getActivityQuestionImage(params.ActivityId || params.surveyid || params))
    // .then((response) => {
    //     try {
    //         //console.log('question image in respondant side survey->', response.payload.content.fileData)
    //         setQImage(response.payload.content.fileData)
    //     } catch (err) { console.log('image in questionnaire not available') }
    //     setIsLoading(false);
    // })
    // .catch(err=>err)



}
        }
    // else if(params.evaluationid){
    //     dispatch(getActivityVideo(params.evaluationid))
    // .then((response) =>{
    //     try{
      
    //     setQVideo(response.payload.content.fileData)}catch(err){console.log('video not available')}
    //     setIsLoading(false);
        
    // })
    // .catch(err=>err)
    // dispatch(getActivityQuestionImage(params.evaluationid))
    //             .then((response) => {
    //                 try {
    //                     //console.log('question image long text in respondant side survey->', response.payload.content.fileData)
    //                     setQImage(response.payload.content.fileData)
    //                 } catch (err) { console.log('image in questionnaire not available') }
    //                 setIsLoading(false);
    //             })
    //             .catch(err=>err)
    // }
}, []);

const makeLinksOpenInNewTab = (htmlContent) => {
    // Create a DOM element to parse the HTML content
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlContent;

    // Find all anchor tags within the parsed HTML content
    const anchorTags = tempElement.getElementsByTagName('a');

    // Iterate through the anchor tags and set the target attribute to '_blank'
    for (const anchorTag of anchorTags) {
        anchorTag.setAttribute('target', '_blank');
        // You can also set 'rel' attribute to 'noopener noreferrer' for security best practices
        anchorTag.setAttribute('rel', 'noopener noreferrer');
    }

    // Return the modified HTML content
    return tempElement.innerHTML;
}

    return (
        <div className="my-3">
            <div className={styles.card_border} style={props.required && !props.isAnswered ? { borderColor: '#d92550' } : {}}>
                <div className={styles.card_border_body + " pt-4 pb-1"}>
                    <p style={{ color: '#666', fontSize: "1rem", fontWeight: '500', whiteSpace: 'pre-wrap' }} className="mb-0">

                        {/* Required check */}
                        {props.required &&
                            <span className="text-danger mr-1">*</span>
                        }

                        {/* Question text */}
                        {props.questionText &&
                          <span  style={{ color: '#000', fontSize: '27px', fontWeight: '500' }} className='mb-0' dangerouslySetInnerHTML={{ __html: makeLinksOpenInNewTab(props.questionText) }} />
                        }


                      {/* Question video */}
                      {props.questionVideo && (
                        <div>
                            
                            <YouTube videoId={props.questionVideo} opts={opts} className='py-4 text-center'></YouTube>
                            
                        </div>
                    )}
                    </p>

                    {/* Question Video */}
                    {
                        props.questionFile && props.questionFile !== '' &&
                        <>
                            {
                                Array.isArray(qVideo) && qVideo.length > 0 ? (
                                    <div className="mx-3 mt-2 mb-4">
                                        <div className="pt-3 d-flex flex-wrap gap-3">
                                            {qVideo.map((file, index) => {
                                                const isVideo = file && file.type && file.type.includes('video');
                                                const src = file ? `data:${file.type};base64,${file.data}` : '';
                                                return file ? (
                                                    <div key={index} className="position-relative">
                                                        {isVideo ? (
                                                            <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
                                                                <ReactPlayer url={src} controls width="100%" />
                                                            </div>
                                                        ) : (
                                                            <img
                                                                src={src}
                                                                className={`img-fluid border ${styles.banner_image}`}
                                                                style={{ borderRadius: '10px' }}
                                                                alt="img"
                                                            />
                                                        )}
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                ) : isLoading ? (
                                    <div className="mx-3 mt-2 mb-4"><b>Loading Media...</b></div>
                                ) : null
                            }
                        </>
                    }

                    <div className="mt-3 mx-3">

                        {/* File Limit and File Size */}
                        <small className="text-danger">
                            Max files Limit: {props.filesLimit ? props.filesLimit : "1"} | Max file Size: {props.filesSize ? props.filesSize : "50"} MB
                        </small>

                        {/* Image Display & Dropzone */}
                        <div className="d-flex flex-wrap pt-3">
                            {Array.from({
                                length: !Number.isNaN(parseInt(props.filesLimit)) && parseInt(props.filesLimit) > 0 ? parseInt(props.filesLimit) : 1
                            }).map((_, slotIndex) => {
                                const imgSrc = props.image && props.image[slotIndex];

                                return (
                                    <div
                                        key={slotIndex}
                                        className="position-relative mr-3 mb-3"
                                        style={{ width: 110, height: 110 }}
                                    >
                                        {imgSrc ? (
                                            <>
                                                <div
                                                    onClick={() => setPreviewIndex(slotIndex)}
                                                    style={{ width: '100%', height: '100%', cursor: 'pointer' }}
                                                >
                                                    <img
                                                        src={typeof imgSrc === 'string' ? imgSrc : URL.createObjectURL(imgSrc)}
                                                        className="img-fluid border"
                                                        style={{ borderRadius: '10px', width: '100%', height: '100%', objectFit: 'cover' }}
                                                        alt="survey-img"
                                                    />
                                                </div>
                                                <span
                                                    onClick={(e) => { e.stopPropagation(); onCancelImg(slotIndex); }}
                                                    style={{
                                                        position: 'absolute',
                                                        top: -8,
                                                        right: -8,
                                                        width: 22,
                                                        height: 22,
                                                        borderRadius: '50%',
                                                        backgroundColor: '#d92550',
                                                        color: '#fff',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        cursor: 'pointer',
                                                        fontSize: 14,
                                                        fontWeight: 'bold',
                                                        zIndex: 2,
                                                        lineHeight: 1,
                                                        boxShadow: '0 0 3px rgba(0,0,0,0.5)'
                                                    }}
                                                >
                                                    &times;
                                                </span>
                                            </>
                                        ) : (
                                            <label
                                                className="d-flex align-items-center justify-content-center border"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    borderRadius: '10px',
                                                    borderStyle: 'dashed',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#f8f9fa',
                                                    margin: 0
                                                }}
                                            >
                                                <input
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => {
                                                        onImageSelect(e.target.files);
                                                        e.target.value = "";
                                                    }}
                                                />
                                                <span className={styles.upload_media_icon} style={{ width: 40, height: 40, backgroundSize: 30 }}></span>
                                            </label>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        {/* {previewIndex !== null && props.image && props.image[previewIndex] && ReactDOM.createPortal(
                            <div
                                style={{
                                    position: 'fixed',
                                    top: 0, left: 0, right: 0, bottom: 0,
                                    backgroundColor: 'rgba(0,0,0,0.75)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 9999
                                }}
                                onClick={() => setPreviewIndex(null)}
                            >
                                <div
                                    style={{ position: 'relative', maxWidth: '90%', maxHeight: '90%', textAlign: 'center' }}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <img
                                        src={typeof props.image[previewIndex] === 'string' ? props.image[previewIndex] : URL.createObjectURL(props.image[previewIndex])}
                                        style={{ maxWidth: '100%', maxHeight: '75vh', borderRadius: 10 }}
                                        alt="preview"
                                    />
                                    <div className="d-flex justify-content-center mt-3">
                                        <button
                                            type="button"
                                            className="btn btn-danger mr-2"
                                            onClick={() => { onCancelImg(previewIndex); setPreviewIndex(null); }}
                                        >
                                            Remove
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-light"
                                            onClick={() => setPreviewIndex(null)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>,
                            document.body
                        )} */}


                        {/* Comment */}
                        {props.isComment && props.isComment && (
                            <div className="form-group mt-1 mb-3">
                                <label>Comment</label>
                                <input className="form-control" type="text" value={props.comment} onChange={onComment} placeholder="Write here" />
                            </div>
                        )}

                    </div>

                    {/* Upload related error */}
                    <div id={`error-msg-${props.id}`}></div>

                    {/* Required Answer error */}
                    {props.required && !props.isAnswered && (
                        <div id={`error-msg`}>
                            <div className="my-2">
                                <div className="alert alert-danger mb-0">
                                    Please answer this question.
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div >
    )

}

export default Question_With_Image2;